import styled from 'styled-components';
import Image from '@stencil/image';
import {ButtonBase, SectionHeader, PrimaryLink} from './generic.styles';

export const ModalSelectWrapperUI = styled.section(
  props => `
  width: ${props.isPWA ? 'unset' : '100%'};
  margin: 0 auto;
  max-width:${props.isPWA ? 'unset' : '71.3rem'};
  background-color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.isPWA ? '12px' : props.theme.misc.borderRadius.xxxlarge};
    `,
);
export const DifferentRoom_Link = styled(PrimaryLink)(
  props => `
    font-size: ${
      props.isPWA ? `${props.theme.font.custom(14)};` : `${props.theme.font.custom(16)};`
    }
    display:${props.isPWA ? 'flex' : 'unset'};
    width:${props.isPWA ? '50%' : 'unset'};
    justify-content:${props.isPWA ? 'center' : 'unset'};
    font-weight:${props.isPWA ? 'normal' : 'unset'};
    `,
);

// font check
export const Proceed_Btn = styled(ButtonBase)(
  props => `
    font-size: ${props.theme.font.custom(16)};
    width:${props.isPWA ? '50%' : '15.5rem'};
    font-family: inherit;
    height:${props.isPWA ? '6rem' : '5.4rem'};
    text-transform:none;
    border-bottom-right-radius:${props.isPWA ? '12px' : props.theme.misc.borderRadius.xxxlarge};
    border-bottom-left-radius: ${props.isPWA ? '0px' : props.theme.misc.borderRadius.xxxlarge};
    border-top-right-radius: ${props.isPWA ? '0px' : props.theme.misc.borderRadius.xxxlarge};
    border-top-left-radius: ${props.isPWA ? '0px' : props.theme.misc.borderRadius.xxxlarge};
    `,
);

// Border Bottom check
export const Header_Wrapper = styled(SectionHeader)(
  props => `
    display:flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
    padding: ${
      props.isPWA
        ? `${props.theme.spacing.custom(12)};`
        : `${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};`
    } 
    border-top-left-radius:${props.isPWA ? '12px' : '0'};
    border-top-right-radius:${props.isPWA ? '12px' : '0'};
    width:${props.isPWA ? '100%' : 'unset'};
    background:${props.isPWA ? props.theme.colors.goWhite.base : 'unset'};
    
  `,
);
export const Middle_ContentWrap = styled.div(
  props => `
    padding: ${
      props.isPWA
        ? `${props.theme.spacing.custom(12)};`
        : `${props.theme.spacing.custom(30)} ${props.theme.spacing.xxlarge};`
    } 
    border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
    background-color: ${props.theme.colors.goWhite.base};
    `,
);
export const SunSet_Image = styled(Image)(
  props => `
    width: 4.8rem;
    height:4.8rem;
    margin-right: ${props.isPWA ? 'unset' : `${props.theme.spacing.large}`};
    position: ${props.isPWA ? 'absolute' : 'unset'};
    top: ${props.isPWA ? '7px' : 'unset'};

  `,
);
export const Text_Para = styled.p(
  props => `
    width:${props.isPWA ? '85%' : '75%'};
    font-size: ${
      props.isPWA ? `${props.theme.font.custom(14)};` : `${props.theme.font.custom(16)};`
    }
    color:#46484d;
    line-height:1.5;
    margin-bottom:${
      props.isPWA ? `${props.theme.spacing.custom(24)}` : `${props.theme.spacing.xxlarge};`
    }
    `,
);
export const Bold_Text_Para = styled.p(
  props => `
      font-size: ${
        props.isPWA ? `${props.theme.font.custom(14)};` : `${props.theme.font.custom(16)};`
      }
      font-weight: bold;
      color: ${props.isProps ? '#46484d' : 'unset'};
      margin-bottom:${props.isProps ? '20px' : 'unset'};;
      `,
);
export const Bottom_ContentWrap = styled.div(
  props => `
    display:flex;
    align-items: center;
    justify-content: ${props.isPWA ? 'unset' : 'space-between'};
    padding: ${
      props.isPWA ? 'unset' : `${props.theme.spacing.custom(24)} ${props.theme.spacing.xxlarge};`
    };
    width:${props.isPWA ? '100%' : 'auto'};
    border-bottom-right-radius:12px;
    border-bottom-left-radius: 12px;
    background-color: ${props.theme.colors.goWhite.base};
    `,
);

export const Circular_WhiteWrap = styled.div(
  props => `
        background: ${props.theme.colors.goWhite.base};
        position: absolute;
        top:-40px;
        border-radius:50%;
        width:78px;
        height:78px;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        display: flex;
        left:41%;
      `,
);

export const HeaderBoldTextPara = styled.p(
  props => `
    font-size:${props.theme.font.custom(18)};
    font-family: ${props.theme.font.fontFamily};
    font-weight:bold;
    color:#46484D;
    width:70%;
    margin-top: 10px;
    position: relative;
      `,
);
